<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('dailySchedulesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="daily-schedule-list-workspace">
      <app-master-table
        [title]="'dailySchedulesCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [pageSizeOptions]="[15, 25, 50, 100, 200]"
        [tableMaxHeight]="'100%'"
        [exportFileName]="'daily-schedules'"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (edit)="handleEdit($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
